<template>
  <TableGradient
      icon-name="broadcast-tower"
      :title="$t('rnds.listagem.titulo_pagina')"
      :text-empty="$t('rnds.listagem.table.empty')"
      :fields="fields"
      :fields-filter="filter"
      :items="transmissoes"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('rnds/listAll', evt)"
      table-data
      disable-filters
  >
    <template v-slot:cell(id)="{ index, item: { id }}">
      <router-link :id="`link-edit-${index}`"
                   :to="{ name: 'rnds.show', params: { id }}"
                   class="font-weight-bold">
        {{ $t('rnds.listagem.table.visualizar') }}
      </router-link>
    </template>
    <template v-slot:cell(created_at)="{ item: { created_at }}">
      {{ created_at | formatDate }}
    </template>
    <template v-slot:cell(status)="{ item: { status }}">
      <span :class="{'rounded-pill p-1 ': true, 'badge badge-success': status === 'success', 'badge badge-danger': status === 'error'}">
          <i :class="status === 'success' ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      transmissoes: 'rnds/all',
      paginator: 'rnds/pagination',
      store_isLoading: 'rnds/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'message', label: this.$t('rnds.listagem.table.mensagem'), sortable: true},
        {key: 'created_at', label: this.$t('rnds.listagem.table.criadoem'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('rnds.listagem.table.visualizar')}
      ],
      filter: [
        {key: 'message', label: this.$t('rnds.listagem.table.mensagem')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'rnds/listAll'
    ])
  },
  mounted() {
    this['rnds/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style scoped>
</style>